import { err, ErrorKind, ok, Result } from "./result";
import fetch from "./fetch";

export const ACCEPTED = "ACCEPTED";
export const REJECTED = "REJECTED";

interface Accepted {
  type: typeof ACCEPTED;
  digits: string;
}

interface Rejected {
  type: typeof REJECTED;
}

type ActiveResult = Accepted | Rejected;

export async function active(url: string): Promise<Result<ActiveResult>> {
  return fetch(url, {
    done: (data) => {
      if (typeof data.digits !== "string") {
        return err(ErrorKind.MalformedMessage, data);
      }
      return ok({
        type: ACCEPTED,
        digits: data.digits,
      });
    },
    rejected: () =>
      ok({
        type: REJECTED,
      }),
  });
}
